import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { DriveEtaOutlined } from "@material-ui/icons";

const useStyles = makeStyles({
  table: {
    width: 1,
  },
});

function createData(name, value) {
  return { name, value };
}

const rows = [createData("Weight", 159), createData("FilledLevel", 3034)];

export default function BasicTable({ mData, unClearedAlarms }) {
  const classes = useStyles();

  let headerNames = [
    "EquipmentID",
    "Location",
    "Capacity(%)",
    "Filled Status",
    "Fault Status",
    "Fault Type",
    "Fault Time/Date",
  ];

  let unClearAlarm;
  if (unClearedAlarms.length > 0) {
    unClearAlarm = unClearedAlarms.find(
      (alarm) => alarm.EquipmentID === mData.EquipmentID
    );
  }

  let dataRows = [];
  for (let headername of headerNames) {
    let data;
    switch (headername) {
      case "Location":
        data = createData(headername, mData["address"]);
        break;
      case "Capacity(%)":
        data = createData(headername, mData["FilledLevel"]);
        break;
      case "Filled Status":
        data = createData(headername, "Normal");
        break;
      case "Fault Status":
        unClearAlarm
          ? (data = createData(headername, unClearAlarm["CurrentStatus"]))
          : (data = createData(headername, "No Fault"));
        break;
      case "Fault Type":
        unClearAlarm
          ? (data = createData(headername, unClearAlarm["Type"]))
          : (data = createData(headername, "No Fault"));
        break;
      case "Fault Time/Date":
        unClearAlarm
          ? (data = createData(headername, unClearAlarm["ts"]))
          : (data = createData(headername, "No Fault"));
        break;
      default:
        data = createData(headername, mData[headername]);
    }
    dataRows.push(data);
  }
  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableBody>
            {dataRows.map((row) => (
              <TableRow key={row["EquipmentID"]}>
                <TableCell align="left">{row["name"]}</TableCell>
                <TableCell align="left">{row["value"]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
